import { Link } from "react-router-dom";

const FormAddTicket = ({ setShow, size }) => {
  return (
    <div className="panel is-link">
        <p className="panel-heading">ADD TICKET</p>
        <div className="panel-tabs p-2">
            <div className="is-inline-flex">
              <Link to="/tickets" className="button has-text-weight-semibold is-small is-info is-outlined mr-2">
                <span className="is-size-6">Cancel</span>                
              </Link>
              
              <button className="button has-text-weight-semibold is-small is-info is-outlined mr-2" onClick={() => setShow('product')}>
                <span className="is-size-6">Show Product List</span>
              </button>
              <button className="button has-text-weight-semibold is-small is-info is-outlined mr-2" onClick={() => setShow('ticket')}>
                <span className="is-size-6">Show Form Ticket<span className="ml-1 has-text-weight-bold">({size})</span></span>
              </button>
              <button className="button has-text-weight-semibold is-small is-info is-outlined" onClick={() => setShow('contract')}>
                <span className="is-size-6">Show Contract</span>
              </button>              
            </div>           
        </div>
    </div>
  );
};

export default FormAddTicket;